<template>
  <transition name="slide-right" :appear="false">
    <div class="view-container">
      <div class="analytic-form display--flex">
        <div class="w-full">
          <div class="card-title page-title">Аналитика</div>
          <div class="card-body">
            <div class="analytic-form__params"></div>

            <div class="analytic-form__report-type justify-content-start grid">
              <div v-for="analytic in analytics.general" :key="analytic.id">
                <router-link
                    v-if="isSuperAdmin || analytic.name !== 'Данные по тестированиям'"
                    :key="analytic.id"
                    :to="analytic.link"
                    class="analytic-link"
                >
                  <div class="link-body">
                    <div class="icon-wrapper">
                      <div class="icon">
                        <img :src="analytic.icon" alt="Иконка">
                      </div>
                    </div>
                    <div class="link-info">
                      <div class="link-header">
                        <a-tag v-if="analytic.tag">
                          {{ analytic.tag }}
                        </a-tag>
                        <RightOutlined class="right-arrow" />
                      </div>
                      <div class="name">{{ analytic.name }}</div>
                      <div class="description">{{ analytic.description }}</div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <div class="card-title">Специальные отчеты</div>
          <div class="card-body">
            <div class="analytic-form__params"></div>

            <div class="analytic-form__report-type justify-content-start grid">
              <div v-for="analytic in analytics.special" :key="analytic.id">
                <router-link
                    v-if="isSuperAdmin || analytic.name !== 'Данные по тестированиям'"
                    :key="analytic.id"
                    :to="analytic.link"
                    @click="(e) => { if (!analytic.available) e.preventDefault() }"
                    class="analytic-link special-link"
                >
                  <div class="link-body">
                    <div class="icon-wrapper">
                      <div class="icon">
                        <img :src="analytic.icon" alt="Иконка">
                      </div>
                    </div>
                    <div class="link-info">
                      <div class="link-header">
                        <a-tag v-if="analytic.tag">
                          {{ analytic.tag }}
                        </a-tag>
                        <RightOutlined v-if="analytic.available" class="right-arrow" />
                      </div>
                      <div class="name">{{ analytic.name }}</div>
                      <div class="description">{{ analytic.description }}</div>
                      <div v-if="!analytic.available" class="button-wrapper">
                        <a-button class="primary-button" @click="handleOrderForm(analytic.product_id)">
                          Получить доступ
                        </a-button>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a-modal v-if="showOrderForm" :width="isMobile ? '100%' : 650" :footer="null" v-model:open="showOrderForm">
        <h2>
          Оформление заявки на продукт
        </h2>
        <new-order-form @close="showOrderForm = false" />
      </a-modal>
    </div>
  </transition>
</template>

<script>
import { ref } from "@vue/reactivity";
import BaseReportParametres from "../../feature/analytics/report-parameters/BaseReportParametres.vue";
import { computed, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import BaseReport from "../../feature/analytics/reports/BaseReport.vue";
import GroupReportParametres from "../../feature/analytics/report-parameters/GroupReportParametres.vue";
import GroupReport from "../../feature/analytics/reports/GroupReport.vue";
import GeneralDynamicParametres from "../../feature/analytics/report-parameters/GeneralDynamicParametres.vue";
import ReferenceReportParametres from "../../feature/analytics/report-parameters/ReferenceReportParametres.vue";
import ReferenceUsersReportParametres from "../../feature/analytics/report-parameters/ReferenceUsersReportParametres.vue";
import RepeatedReportParametres from "../../feature/analytics/report-parameters/RepeatedReportParametres.vue";
import DemographicReportParametres from "../../feature/analytics/report-parameters/DemographicReportParametres.vue";
import DemographicReport from "../../feature/analytics/reports/DemographicReport.vue";
import ReferenceUsersReport from "../../feature/analytics/reports/ReferenceUsersReport.vue";
import useCheckRights from "../../mixins/useCheckRights";
import analyticsReports from "../../mixins/dictionaries/analyticsReports";
import CustomSelect2 from "../../components/Forms/Fields/CustomSelect2.vue";
import {RightOutlined} from "@ant-design/icons-vue";
import NewOrderForm from "@/views/Orders/OrderForm.vue";
import {onMounted} from "vue";

export default {
  components: {
    NewOrderForm,
    CustomSelect2,
    BaseReportParametres,
    BaseReport,
    GroupReportParametres,
    GroupReport,
    GeneralDynamicParametres,
    ReferenceReportParametres,
    ReferenceUsersReportParametres,
    RepeatedReportParametres,
    DemographicReportParametres,
    DemographicReport,
    ReferenceUsersReport,
    RightOutlined
  },
  name: "analytic-form",
  setup() {
    const store = useStore(),
      { getRight } = useCheckRights();
    const reportType = ref(null),
      reportRequest = ref(false),
      groupId = ref(null);
    const winWidth = computed(() => store.state.width),
      reportData = computed(() => store.state.analytics.reportData),
      reportReservedData = computed(
        () => store.state.analytics.reportReservedData
      );
    const analytics = analyticsReports;
    const showOrderForm = ref(false);

    const handleOrderForm = (product) => {
      store.dispatch('relations/setInsufficientProducts', {
        analytics: [{
          product_id: product
        }]
      });

      showOrderForm.value = true;
    }

    const print = () => {
      window.print();
    };

    const isSuperAdmin = computed(() => getRight('superadmin'));

    watch(reportType, () => {
      reportRequest.value = false;
      store.commit("analytics/setReportData", null);
    });

    const isMobile = ref(window.innerWidth <= 768)

    const onResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    return {
      reportType,
      reportRequest,
      print,
      winWidth,
      reportData,
      reportReservedData,
      getRight,
      groupId,
      analytics,
      isSuperAdmin,
      showOrderForm,
      handleOrderForm,
      isMobile
    };
  },
};
</script>

<style lang="scss" scoped>
.card-title {
  text-align: left;
  font-weight: 600;
  font-size: 20px;
}

.card-body {
  margin-bottom: 20px;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.2s ease-out;
}

.slide-right-leave-to,
.slide-right-enter-from {
  opacity: 0;
  transform: translateX(-1000px);
}
.analytic-form {
  &__options,
  &__report-type {
    margin: 20px auto;

    .btn {
      margin-right: 10px;
    }
  }
  &__report-type {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  &__description {
    background-color: var(--cream-color);
    width: 100%;
    padding: 20px;
    height: 220px;
    text-overflow: ellipsis;
    margin-left: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  &__table {
    margin-top: 40px;
  }

  &__report-title {
    font-size: 1.1rem;
    font-weight: 300;
    color: #3d3d3d;
    padding: 24px 0 14px;
    margin: 0 25px;
    border-bottom: 0 solid rgba(0, 0, 0, 0.125);
    line-height: 1.738;
  }

  @media (max-width: 1400px) {
    &__report-type {
      grid-template-columns: 1fr;
    }

    &__description {
      margin-top: 20px;
      margin-left: 0;
    }
  }
}
.analytic-link {
  display: flex;
  padding: 20px;
  border-bottom: 1px solid var(--cream-color);
  justify-content: center;
  background-color: #FFFFFF;
  border-radius: 16px;
  height: 200px;

  .link-body {
    display: flex;
    width: 100%;
  }

  .icon-wrapper {
    margin-right: 18px;
    min-width: 60px;
    width: 60px;
    height: 60px;
    background-color: var(--light-grey);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
  }

  .icon img {
    width: 40px;
  }

  .name {
    margin: 10px 0;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
  }

  .description {
    text-align: left;
    font-size: 15px;
  }

  .right-arrow {
    color: var(--grey-text);
  }

  &:hover {
    .right-arrow {
      color: var(--main-green);
    }
  }

  .link-info {
    text-align: left;
    display: flex;
    flex-direction: column;
  }

  .link-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 1024px) {
    padding: 17px;
    .link-body {
      min-width: 100%;
    }

    .name {
      font-size: 16px;
    }
  }

  @media (max-width: 500px) {
    height: 270px;
  }
}

.special-link {
  height: 290px;

  @media (max-width: 500px) {
    height: 350px;
  }
}

.button-wrapper {
  margin-top: auto;

  @media (max-width: 500px) {
    button {
      width: 100%;
    }
  }
}

.page-title {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: block;
    font-size: 20px;
    font-weight: 500;
  }
}

.view-container {
  padding: 0;
}
</style>
